module.exports = __webpack_public_path__ + "static/media/012-line-blue.8e3a6281.svg";